exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".month-main .ant-picker-header {\n  display: none !important; }\n", ""]);

// exports
